/* FRESK cart + UI (vanilla, no libraries) */
(function(){
  'use strict';
  var currency = (window.freskCurrency || 'USD');
  var fmt = function(cents){
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency: currency}).format(cents/100); }
    catch(e){ return (cents/100).toFixed(2) + ' ' + currency; }
  };
  window.freskFormatMoney = fmt;

  function qs(s,root){ return (root||document).querySelector(s); }
  function qsa(s,root){ return Array.prototype.slice.call((root||document).querySelectorAll(s)); }

  var toastTimer = null;
  function toast(msg){
    var t = qs('.fresk-toast');
    if(!t){ t = document.createElement('div'); t.className='fresk-toast'; t.setAttribute('role','status'); document.body.appendChild(t); }
    t.innerHTML = '<span style="color:#9BA895;font-weight:700">✓</span>' + msg;
    t.style.display='flex';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ t.style.display='none'; }, 2600);
  }

  function updateCounts(cart){
    qsa('[data-fresk-cart-count]').forEach(function(el){
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
  }

  function drawerEls(){
    return { drawer: qs('[data-fresk-drawer]'), overlay: qs('[data-fresk-drawer-overlay]') };
  }

  function openDrawer(){
    var d = drawerEls();
    if(!d.drawer) return;
    d.drawer.classList.add('is-open');
    d.overlay && d.overlay.classList.add('is-open');
    d.drawer.setAttribute('aria-hidden','false');
    refresh();
  }
  function closeDrawer(){
    var d = drawerEls();
    if(!d.drawer) return;
    d.drawer.classList.remove('is-open');
    d.overlay && d.overlay.classList.remove('is-open');
    d.drawer.setAttribute('aria-hidden','true');
  }

  function renderDrawer(cart){
    var d = drawerEls();
    if(!d.drawer) return;
    updateCounts(cart);
    var list = qs('[data-fresk-drawer-items]', d.drawer);
    var empty = qs('[data-fresk-drawer-empty]', d.drawer);
    var foot = qs('[data-fresk-drawer-foot]', d.drawer);
    if(!list) return;
    if(cart.item_count === 0){
      list.innerHTML='';
      if(empty) empty.hidden = false;
      if(foot) foot.hidden = true;
      return;
    }
    if(empty) empty.hidden = true;
    if(foot) foot.hidden = false;
    list.innerHTML = cart.items.map(function(it, i){
      var img = it.image ? it.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_160x$1$2') : '';
      var vt = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      var cmp = '';
      return '<div class="fresk-drawer__item" data-line="'+(i+1)+'">'
        + '<div class="fresk-drawer__thumb">' + (img ? '<img src="'+img+'" alt="" width="72" height="72" loading="lazy">' : '') + '</div>'
        + '<div style="flex:1;min-width:0">'
        + '<p style="margin:0 0 2px;font-size:14px;font-weight:600;color:#1E1E1E">' + it.product_title + '</p>'
        + (vt ? '<p style="margin:0 0 8px;font-size:12.5px;color:#6B675F">' + vt + '</p>' : '')
        + '<div style="display:flex;align-items:center;gap:12px">'
        + '<div class="fresk-qty" role="group" aria-label="Quantity">'
        + '<button type="button" data-fresk-qty="-1" aria-label="Decrease quantity">−</button>'
        + '<span aria-live="polite">' + it.quantity + '</span>'
        + '<button type="button" data-fresk-qty="1" aria-label="Increase quantity">+</button>'
        + '</div>'
        + '<button type="button" data-fresk-remove style="background:none;border:none;cursor:pointer;font-size:12.5px;color:#8D8A83;text-decoration:underline">Remove</button>'
        + '</div></div>'
        + '<div style="text-align:right">'
        + '<span style="font-size:14px;font-weight:700;color:#1E1E1E">' + fmt(it.final_line_price) + '</span>'
        + (it.original_line_price > it.final_line_price ? '<br><s style="font-size:12px;color:#A29D93">' + fmt(it.original_line_price) + '</s>' : '')
        + '</div></div>';
    }).join('');
    var sub = qs('[data-fresk-subtotal]', d.drawer);
    if(sub) sub.textContent = fmt(cart.items_subtotal_price);
    var savedWrap = qs('[data-fresk-savings-wrap]', d.drawer);
    var saved = qs('[data-fresk-savings]', d.drawer);
    var totalSave = cart.total_discount || 0;
    cart.items.forEach(function(it){
      if(it.compare_at_price && it.compare_at_price > it.price){ totalSave += (it.compare_at_price - it.price) * it.quantity; }
    });
    if(saved && savedWrap){ savedWrap.hidden = totalSave <= 0; saved.textContent = fmt(totalSave); }
    var prog = qs('[data-fresk-progress]', d.drawer);
    if(prog){
      var threshold = parseInt(prog.getAttribute('data-threshold'), 10) || 0;
      var bar = qs('[data-fresk-progress-bar]', d.drawer);
      var msg = qs('[data-fresk-progress-msg]', d.drawer);
      if(threshold > 0){
        var pct = Math.min(100, Math.round(cart.items_subtotal_price / threshold * 100));
        if(bar) bar.style.width = pct + '%';
        if(msg){
          msg.textContent = cart.items_subtotal_price >= threshold
            ? (prog.getAttribute('data-msg-done') || 'You have free delivery!')
            : (prog.getAttribute('data-msg-todo') || 'away from free delivery').replace('[amount]', fmt(threshold - cart.items_subtotal_price));
        }
      } else { prog.hidden = true; }
    }
    var bump = qs('[data-fresk-bump]', d.drawer);
    if(bump){
      var bumpVid = bump.getAttribute('data-variant-id');
      var inCart = cart.items.some(function(it){ return String(it.variant_id) === String(bumpVid); });
      bump.hidden = inCart;
    }
  }

  function refresh(){
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){ renderDrawer(cart); return cart; });
  }

  function add(id, qty){
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({items:[{id: parseInt(id,10), quantity: qty || 1}]})
    }).then(function(r){
      if(!r.ok) throw new Error('add failed');
      return r.json();
    });
  }

  function changeLine(line, qty){
    return fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({line: line, quantity: qty})
    }).then(function(r){ return r.json(); }).then(renderDrawer);
  }

  window.freskCart = { add: add, open: openDrawer, close: closeDrawer, refresh: refresh, toast: toast };

  document.addEventListener('click', function(e){
    var atc = e.target.closest('[data-fresk-atc]');
    if(atc){
      e.preventDefault();
      var id = atc.getAttribute('data-variant-id');
      if(!id) return;
      var oldTxt = atc.textContent;
      atc.setAttribute('aria-busy','true');
      add(id, parseInt(atc.getAttribute('data-qty')||'1',10)).then(function(){
        atc.removeAttribute('aria-busy');
        if(atc.hasAttribute('data-checkout')){ window.location.href='/checkout'; return; }
        toast((atc.getAttribute('data-added-msg') || 'Added to cart'));
        openDrawer();
      }).catch(function(){
        atc.removeAttribute('aria-busy');
        window.location.href = '/cart';
      });
      return;
    }
    if(e.target.closest('[data-fresk-drawer-open]')){ e.preventDefault(); openDrawer(); return; }
    if(e.target.closest('[data-fresk-drawer-close]') || e.target.closest('[data-fresk-drawer-overlay]')){ e.preventDefault(); closeDrawer(); return; }
    var qbtn = e.target.closest('[data-fresk-qty]');
    if(qbtn){
      var row = qbtn.closest('[data-line]');
      var span = row.querySelector('.fresk-qty span');
      var q = parseInt(span.textContent,10) + parseInt(qbtn.getAttribute('data-fresk-qty'),10);
      changeLine(parseInt(row.getAttribute('data-line'),10), Math.max(0,q));
      return;
    }
    var rm = e.target.closest('[data-fresk-remove]');
    if(rm){
      var row2 = rm.closest('[data-line]');
      changeLine(parseInt(row2.getAttribute('data-line'),10), 0);
      return;
    }
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('DOMContentLoaded', function(){
    fetch('/cart.js').then(function(r){return r.json();}).then(updateCounts).catch(function(){});
  });
})();
